module.exports = __webpack_public_path__ + "img/bingo-instrucciones.5767baa8.png";